import { useState, useEffect, useCallback } from "react";
import { getMyPageData } from "../utils/api";

const useMyPageData = (accountKey) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const fetchMyPageData = useCallback(async () => {
    try {
      setIsLoading(true);
      setIsError(false);
      setError(null);

      const response = await getMyPageData(accountKey);
      setData(response);
    } catch (err) {
      setIsError(true);
      setError(err);
      console.error("Failed to fetch my page data:", err);
    } finally {
      setIsLoading(false);
    }
  }, [accountKey]);

  useEffect(() => {
    fetchMyPageData();
  }, [accountKey, fetchMyPageData]);

  const refetch = () => {
    fetchMyPageData();
  };

  return {
    data,
    isLoading,
    isError,
    error,
    // 2026-04-14 時点で参照箇所なし。backend の StateDTO にも is_before_purchase は存在せず常に false。
    isBeforePurchase: data?.is_before_purchase || false,
    refetch,
    currentStory: data?.stories?.current || null,
    previousStories: data?.stories?.previous || [],
    canProceedToNextPhase: data?.can_proceed_to_next_phase || false,
    nextPhaseControl: data?.next_phase_control || null,
    remainingDays: data?.remaining_days || 0,
    expireAt: data?.expire_at || null,
    isExpired: data?.is_expired || false,
    canReset: data?.can_reset || false,
  };
};

export default useMyPageData;
